import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/farmacias/';

export default {
  async estadisticas(farmacia) {
    const response = await axios.post(API_URL + "estadisticas", farmacia, { headers: authHeader() });
    if (response.data) {
      return response.data;
    }
  },
};
